import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Row, Form, Input, Checkbox } from 'antd'
import { config } from '@/config'
import styles from './index.less'
import LoginActions from '@/redux/LoginRedux'
import WebIM from '@/config/WebIM'
import Axios from 'axios'

const FormItem = Form.Item

const Login = ({
    I18N,
    login,
    doLogin,
    doLoginByToken,
    jumpRegister,
    form: { getFieldDecorator, validateFieldsAndScroll }
}) => {
    const { loginLoading } = login

    const handleOk = () => {
        validateFieldsAndScroll((errors, values) => {
            if (errors) {
                return
            }
              /**
             * 请求域名-api_domain字段： https://u2g2l0b1.oss-cn-shanghai.aliyuncs.com/p22UOn1En2s5Fu
             *暂使用第一个域名 fu2gw1.skrwell.com
             *正式环境 13330989511  111000
            测试环境客服 18610001111 密码:999999
             *  mobile = 18610006666;mobileChkCode = 186315;
             测试：  http://f1u0g2w2-t01.douquwl88.com/
             正式：   http://f1u0g2w2.adcecam.cn/
             */

             const url='http://f1u0g2w2.douquwl88.com/'+'front/account/login.json'
             const data='code=86&deviceNo=D6082E4A-B7D6-47DB-9590-59C4ED3BCCDA&mobile='+values.username+
             '&mobileChkCode='+values.password+'&nonce=1644549825877&signature=7F7AD81747967739420537ED11AECEAC&terminal=1&timestamp=1644549825877&version=1.0.0'
             
             Axios.request({
                 headers: {
                     'Content-Type': 'application/x-www-form-urlencoded'
                 },
                 url ,
                 data,
                 method: 'post'
             }).then(res => {
                 if(res.status===200){
                     const res2=res.data.hostUser
                     doLogin(res2.hxUserName, res2.userId)
                 }else{
                     console.log('/=/返回错误：',res)
                 }
             })
            // console.log(values)
            // if (values.type) {
            //     doLoginByToken(values.username, values.password)
            // } else {
            //     doLogin(values.username, values.password)
            // }
        })
    }

    // const a = {}
    // const b = a.b.c
    // console.log(messageList, "---")

    const logo = WebIM.config.i18n == 'cn' ? <i className='font'>V</i> : <i className="iconfont icon-hyphenate"/>
    return (
        <div className="form x-login">
            <div className="logo">
                {logo}
                <span>{config.name}</span>
            </div>
            <form>
                <FormItem hasFeedback>
                    {getFieldDecorator('username', {
                        rules: [
                            {
                                required: true
                            }
                        ]
                    })(<Input size="large" onPressEnter={handleOk} placeholder={I18N.username}/>)}
                </FormItem>
                <FormItem hasFeedback>
                    {getFieldDecorator('password', {
                        rules: [
                            {
                                required: true
                            }
                        ]
                    })(<Input size="large" type="password" onPressEnter={handleOk} placeholder={I18N.password}/>)}
                </FormItem>
                {/* <FormItem hasFeedback>{getFieldDecorator('type')(<Checkbox>{I18N.tokenSignin}</Checkbox>)}</FormItem> */}
                <Row>
                    <Button type="primary" size="large" onClick={handleOk} loading={loginLoading}>
                        {I18N.signIn}
                    </Button>
                </Row>
            </form>
            {/* <div className="extra">
                <p>
                    {I18N.noaccount}
                    <span onClick={jumpRegister}>{I18N.signUp}</span>
                </p>
            </div> */}
        </div>
    )
}

Login.propTypes = {
    form: PropTypes.object,
    login: PropTypes.object,
    dispatch: PropTypes.func
}

export default connect(
    ({ login, i18n }) => ({
        I18N: (i18n.locale && i18n.translations && i18n.translations[i18n.locale]) || {},
        login: {
            loginLoading: false
        }
    }),
    dispatch => ({
        doLogin: (username, password) => dispatch(LoginActions.login(username, password)),
        doLoginByToken: (username, token) => dispatch(LoginActions.loginByToken(username, token)),
        jumpRegister: () => dispatch(LoginActions.jumpRegister())
    })
)(Form.create()(Login))
